import React from 'react';
import styled from 'styled-components';
import Image, { ImageProps } from 'next/image';
import { Trans } from '@lingui/react';
import { Container } from '@components/layout/Grid';

const testimonials = [
  {
    img:
      'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/839/c47/c9-/original/ann-sofie-42k.jpg',
    quote: <Trans id="landingpage.testimonials.item1.quote" />,
    name: <Trans id="landingpage.testimonials.item1.name" />,
    title: <Trans id="landingpage.testimonials.item1.title" />,
  },
  {
    img:
      'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/eb6/bda/dc-/original/lori-26k.jpg?1613380370',
    quote: <Trans id="landingpage.testimonials.item2.quote" />,
    name: <Trans id="landingpage.testimonials.item2.name" />,
    title: <Trans id="landingpage.testimonials.item2.title" />,
  },
  {
    img:
      'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/95b/917/98-/original/malinmagnusson-45k.jpg?1613380370',
    quote: <Trans id="landingpage.testimonials.item3.quote" />,
    name: <Trans id="landingpage.testimonials.item3.name" />,
    title: <Trans id="landingpage.testimonials.item3.title" />,
  },
  {
    img:
      'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/82d/0a7/d4-/original/annaahlgren-41k.jpg?1613380371',
    quote: <Trans id="landingpage.testimonials.item4.quote" />,
    name: <Trans id="landingpage.testimonials.item4.name" />,
    title: <Trans id="landingpage.testimonials.item4.title" />,
  },
];

const Title = styled.p`
  color: #3c3c3c;
  font-size: 22px;
  text-align: center;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(250px, 1fr));
  row-gap: 40px;
  margin: 40px 0;

  @media (min-width: ${({ theme }) => theme.viewports.tablet}px) {
    grid-template-columns: repeat(2, minmax(250px, 1fr));
  }

  @media (min-width: ${({ theme }) => theme.viewports.laptop}px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`;

const Item = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.viewports.tablet}px) {
    :nth-of-type(n + 3) {
      display: none;
    }
  }
`;

const Avatar = styled(Image)<ImageProps>`
  width: 150px;
  border-radius: 50%;
  margin-bottom: 20px;
  overflow: hidden;
`;

const Quote = styled.p`
  flex: 1;
  color: #3c3c3c;
  font-size: 16px;
  padding: 0 14px;
  margin: 10px 0 20px;
`;

const Name = styled.p`
  font-size: 16px;
  margin: 0;
`;

const PersonTitle = styled.p`
  margin: 0;
`;

const TestimonialsSection = ({ className = '' }) => {
  return (
    <Container
      className={className}
      flexDirection="column"
      px={[25, 20, 20]}
      py={40}
    >
      <Title>
        <Trans id="landingpage.section7.title" />
      </Title>
      <Content>
        {testimonials.map((testimonial, i) => {
          return (
            <Item key={i}>
              <Avatar src={testimonial.img} alt="" width={150} height={150} />
              <Quote>{testimonial.quote}</Quote>
              <Name>{testimonial.name}</Name>
              <PersonTitle>{testimonial.title}</PersonTitle>
            </Item>
          );
        })}
      </Content>
    </Container>
  );
};

export default TestimonialsSection;
